var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7B7869;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,12,6,12z M6,1C3.2,1,1,3.2,1,6s2.2,5,5,5s5-2.2,5-5 S8.8,1,6,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,7.2V5.7c0.5,0,0.9-0.1,1.1-0.3C6.7,5.2,6.8,5,6.8,4.6V4.5c0-0.3-0.1-0.5-0.2-0.6C6.4,3.7,6.2,3.6,6,3.6 c-0.3,0-0.5,0.1-0.7,0.2C5.1,4.1,5,4.3,4.9,4.5l-1-0.4C4,3.9,4,3.7,4.1,3.6c0.1-0.2,0.2-0.3,0.4-0.5c0.2-0.1,0.4-0.3,0.6-0.3 C5.4,2.6,5.7,2.6,6,2.6c0.3,0,0.6,0,0.9,0.1C7.1,2.8,7.3,3,7.5,3.1c0.2,0.2,0.3,0.4,0.4,0.6C8,4,8.1,4.2,8.1,4.5 c0,0.3,0,0.5-0.1,0.7C7.9,5.5,7.7,5.6,7.6,5.8C7.4,6,7.3,6.1,7.1,6.2C6.9,6.3,6.6,6.3,6.4,6.4v0.8H5.3z M5.9,9.4 c-0.3,0-0.5-0.1-0.6-0.2C5.2,9.1,5.1,8.9,5.1,8.7V8.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.6-0.2c0.3,0,0.5,0.1,0.6,0.2 c0.1,0.1,0.2,0.3,0.2,0.5v0.2c0,0.2-0.1,0.4-0.2,0.5C6.3,9.3,6.1,9.4,5.9,9.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.3c3ce11bcb7ea8f22d73c0e6b9ae8431.svg";
export { ForwardRef as ReactComponent };